import { ChangeDetectionStrategy, Component, InputSignal, input } from '@angular/core';
import { MatAnchor } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'mp-zendesk-help-center-flyout-actions',
  templateUrl: './zendesk-help-center-flyout-actions.component.html',
  styleUrl: './zendesk-help-center-flyout-actions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatAnchor, MatIcon],
})
export class ZendeskHelpCenterFlyoutActionsComponent {
  readonly helpCenterLink: InputSignal<string | null> = input.required<string | null>();
}
